export default "__VITE_ASSET__ac2e69ec__"